import Styles from './SelectImage.module.scss'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  imageUrl?: string
  onBack: () => void
}

export const ConfirmImage = ({ imageUrl, onBack }: Props) => {
  return (
    <div className={Styles.confirmImageContainer}>
      <div className={Styles.confirmImage}>
        <Text variant="largeList">We'll add this image to your post</Text>
        <img src={imageUrl} alt="selected" />
      </div>
      <Button variant="secondary" onPress={onBack}>
        Change Image
      </Button>
    </div>
  )
}
